export const resetLogin = () => ({
  type: 'RESET_LOGIN',
})
